/**
 * Booked slot event content renderer for the manual calendar.
 * Shows interview name (truncated) + time range with a hover tooltip.
 * Handles error state for >24hr duration.
 *
 * Ref: KInterviewScheduler/.../ManualBookedContent.tsx + CalEventContent.tsx
 */
import { Flex } from '@chakra-ui/react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@kula-ai/components';
import {
  formatEventTime,
  getEventPadding,
  calcDurationMinutes,
} from './eventHelpers';

interface BookedEventContentProps {
  interviewName?: string;
  start: string;
  end: string;
  timezone?: string;
}

export const BookedEventContent = ({
  interviewName,
  start,
  end,
  timezone,
}: BookedEventContentProps) => {
  const title = interviewName || 'Interview';
  const time = formatEventTime(start, end, timezone);
  const duration = calcDurationMinutes(start, end);
  const padding = getEventPadding(duration);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            style={{
              width: '100%',
              height: '100%',
              padding,
              overflow: 'hidden',
              cursor: 'pointer',
            }}
          >
            <div
              style={{
                fontSize: '11px',
                fontWeight: 500,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: 'inherit',
              }}
            >
              {title}
            </div>
            <div
              style={{
                fontSize: '10px',
                whiteSpace: 'nowrap',
                color: 'inherit',
                opacity: 0.9,
              }}
            >
              {time}
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom" align="start">
          <Flex flexDir="column" gap="2px">
            <span>{title}</span>
            <span>{time}</span>
          </Flex>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
